module.exports = __webpack_public_path__ + "img/95e8ec75ebb4756d28b18b30848c16ca.png";